/**
 * The user's own embroidery machine, remembered in the browser. New projects start with this
 * machine and its default hoop; opened projects keep the machine they were saved with.
 */
import { hoopForMachine, machineById } from '../engine/model/machines';
import type { Design } from '../engine/model/types';

const STORAGE_KEY = 'stitchcraft.machine';

export function loadPreferredMachine(): string | null {
  try {
    const id = localStorage.getItem(STORAGE_KEY);
    return machineById(id) ? id : null;
  } catch {
    return null; // storage unavailable
  }
}

export function setPreferredMachine(id: string | null): void {
  try {
    if (id) localStorage.setItem(STORAGE_KEY, id);
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* storage unavailable; the choice lasts for this project */
  }
}

/** Applies the remembered machine (and a hoop it accepts) to a new design. */
export function withPreferredMachine(design: Design, machineId: string | null = loadPreferredMachine()): Design {
  if (!machineId) return design;
  return { ...design, machine: { ...design.machine, machineId, hoop: hoopForMachine(machineId, design.machine.hoop) } };
}
